import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FiLogOut, FiUser } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAuthenticated, logout, isSuperAdmin, isDistrictAdmin } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Don't show header on login page
  if (location.pathname === '/login') {
    return null;
  }

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <Link
            to={isAuthenticated() ? '/' : '/survey'}
            className="text-2xl font-bold text-primary-600 hover:text-primary-700 transition-colors"
          >
            Career Interest Dashboard
          </Link>

          <nav className="flex items-center space-x-4">
            {isAuthenticated() ? (
              <>
                {/* Authenticated Navigation */}
                <Link
                  to="/"
                  className="text-gray-600 hover:text-gray-900 font-medium transition-colors"
                >
                  Dashboard
                </Link>
                <Link
                  to="/reports"
                  className="text-gray-600 hover:text-gray-900 font-medium transition-colors"
                >
                  Reports
                </Link>
                {user?.role === 'superAdmin' && (
                  <Link
                    to="/institutes"
                    className="text-gray-600 hover:text-gray-900 font-medium transition-colors"
                  >
                    Institutes
                  </Link>
                )}
                {(isSuperAdmin() || isDistrictAdmin()) && (
                  <>
                    <Link
                      to="/roster"
                      className="text-gray-600 hover:text-gray-900 font-medium transition-colors"
                    >
                      Manage Students
                    </Link>
                    <Link
                      to="/access"
                      className="text-gray-600 hover:text-gray-900 font-medium transition-colors"
                    >
                      Manage Access
                    </Link>
                  </>
                )}

                {/* User Info and Logout */}
                <div className="flex items-center space-x-3 ml-4 pl-4 border-l border-gray-300">
                  <div className="flex items-center space-x-2">
                    <FiUser className="h-5 w-5 text-gray-500" />
                    <span className="text-sm font-medium text-gray-700">
                      {user?.first_name} {user?.last_name}
                    </span>
                  </div>
                  <button
                    onClick={handleLogout}
                    className="flex items-center space-x-1 text-gray-600 hover:text-red-600 font-medium transition-colors"
                  >
                    <FiLogOut className="h-4 w-4" />
                    <span>Logout</span>
                  </button>
                </div>
              </>
            ) : (
              <>
                {/* Only show Sign In when not already on the survey */}
                {!location.pathname.startsWith('/survey') && (
                  <Link
                    to="/login"
                    className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium transition-colors"
                  >
                    Sign In
                  </Link>
                )}
              </>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
